import axios from '@/libs/api.request'

export const getTableData = () => {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  })
}

export const getDragList = () => {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  })
}

export const errorReq = () => {
  return axios.request({
    url: 'error_url',
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return axios.request({
    url: 'save_error_logger',
    data: info,
    method: 'post'
  })
}

export const uploadImg = formData => {
  return axios.request({
    url: 'image/upload',
    data: formData
  })
}

export const getOrgData = () => {
  return axios.request({
    url: 'get_org_data',
    method: 'get'
  })
}

export const getTreeSelectData = () => {
  return axios.request({
    url: 'get_tree_select_data',
    method: 'get'
  })
}

export const getDataSummary = () => {
  return axios.request({
    url: 'report/getDataSummary',
    method: 'get'
  })
}

export const getUserDuaTrend = (params) => {
  return axios.request({
    url: 'report/getUserDuaTrend',
    method: 'get',
    params: params
  })
}

export const getDailyTrend = (params) => {
  return axios.request({
    url: 'report/getDailyTrend',
    method: 'get',
    params: params
  })
}

export const getDayRegionVisit = (params) => {
  return axios.request({
    url: 'report/getDayRegionVisit',
    method: 'get',
    params: params
  })
}

export const getLotteryTypeStatistics = (params) => {
  return axios.request({
    url: 'report/getLotteryTypeStatistics',
    method: 'get',
    params: params
  })
}

export const getUserVisits = (params) => {
  return axios.request({
    url: 'report/getUserVisits',
    method: 'get',
    params: params

  })
}

export const getUserBetInfo = (params) => {
  return axios.request({
    url: 'report/getUserBetInfo',
    method: 'get',
    params: params
  })
}

export const getSourceVisitsStat = (params) => {
  return axios.request({
    url: 'report/getSourceVisitsStat',
    method: 'get',
    params: params
  })
}

export const getPlatformVisitsStat = (params) => {
  return axios.request({
    url: 'report/getPlatformVisitsStat',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js